export default __webpack_public_path__ + "static/media/favicon.d6d67af9.ico";